import apiCall from '@/repository'

class MeService {
    baseUrl = '/v1/me';

    getCurrentUser = () => {
        return apiCall.get(`${this.baseUrl}`);
    }

    updateCurrentUser = (newUser) => {
        return apiCall.patch(`${this.baseUrl}`, { ...newUser });
    }

    verifyEmail = (oobCode) => {
        return apiCall.post(`${this.baseUrl}/verify/email`, {
            oobCode
        });
    }

    changePassword = (oobCode, newPassword) => {
        return apiCall.post(`${this.baseUrl}/change/password`, {
            oobCode,
            newPassword
        });
    }

    newPassword = (oldPassword, newPassword) => {
        return apiCall.patch(`${this.baseUrl}/password`, { oldPassword, newPassword });
    }

    addSpaceownerNotificationToken = (token) => {
        return apiCall.put(`${this.baseUrl}/notifications/spaceowner?token=${token}`);
    }

    addAdminNotificationToken = (token) => {
        return apiCall.put(`${this.baseUrl}/notifications/admin?token=${token}`);
    }

    deleteSpaceownerNotificationToken = (token) => {
        return apiCall.delete(`${this.baseUrl}/notifications/spaceowner?token=${token}`);
    }

    deleteAdminNotificationToken = (token) => {
        return apiCall.delete(`${this.baseUrl}/notifications/admin?token=${token}`);
    }

    confirmEmail = (email) => {
      let language = navigator.language || navigator.userLanguage;
          language = language.split('-')[0];
      return apiCall.put(`${this.baseUrl}/verify/email`, {
          email,
          language
      });
  }
}

export default new MeService();



// WEBPACK FOOTER //
// ./src/services/me.js